import { UiIconComponent } from '@/ui/icon/ui-icon';
import { Component, Input, inject } from '@angular/core';
import { AdvizeoTooltipDirective } from '../../directives/advizeo-tooltip/advizeo-tooltip.directive';
import { StripHtmlPipe } from '../../pipes/strip-html/strip-html.pipe';
import { TruncatePipe } from '../../pipes/truncate.pipe';
import { AdvizeoModalService } from '../../services/advizeo-modal.service';
import { HelpMeModalComponent } from './help-me-modal/help-me-modal';

@Component({
    styleUrls: ['./help-me.scss'],
    selector: 'help-me',
    templateUrl: 'help-me.html',
    imports: [UiIconComponent, AdvizeoTooltipDirective, TruncatePipe, StripHtmlPipe]
})
export class HelpMeComponent {
    private _advizeoModalService = inject(AdvizeoModalService);

    @Input() text!: string;

    @Input() title: string = '';
    @Input() modalText: string = '';

    textLengthLimit: number = 150;

    displayHelp() {
        if (this.canOpenModal()) {
            this._advizeoModalService.openAdvizeoModal(HelpMeModalComponent, {
                title: this.title,
                text: this.modalText ? this.modalText : this.text
            });
        }
    }

    canOpenModal() {
        return (this.text && this.text.length > this.textLengthLimit) || this.modalText;
    }
}
